import Vue from "vue";

import operation from "@/core/api/operation.serve";
import manage from "@/core/api/manage.serve";
import caibian from "@/core/api/caibian.serve"; //采编
import expert from "@/core/api/expert.serve"; //专家
import finance from "@/core/api/finance.serve"; //财务
import organizational from "@/core/api/organizational.serve"; //集团管理
import editorialReview from "@/core/api/editorialReview.serve"; //编辑部审核
import echarts from "@/core/api/echarts.serve"; //编辑部审核
import shouye from "@/core/api/shouye.serve"; //首页

const apis = {
  operation,
  manage,
  caibian,
  expert,
  finance,
  organizational,
  editorialReview,
  echarts,
  shouye
};
export default {
  install() {
    Vue.prototype.$apis = apis;
  },
};



// WEBPACK FOOTER //
// ./src/core/api/config/index.js